'use strict';

customerZone.service('shippingInfoProvider', ['UnleashedClient', '$q', '$log', 'Session', function(api, $q, $log,
    Session) {

    var self = this;

    /**
     * Get a promise to the default shipping address for a given customer profile.
     * If no profile is given, the current logged in one is used.
     */
    self.getDefaultShippingAddress = function(customerProfile){
        if (!customerProfile) customerProfile = Session.profile();

        if (!customerProfile) {
            $log.debug('Could not determine customer profile, will use empty shipping info.');
            return $q.when({});
        }

        return $q.when({
            firstName: customerProfile.firstName,
            lastName: customerProfile.lastName,
            company: customerProfile.company ? customerProfile.company : '',
            address: angular.copy(customerProfile.address)
        });
    };
}]);
